// Videos.js
import React, { useState, useEffect } from "react";
import "./resources.css";
import { BsChevronDoubleRight } from "react-icons/bs";
import axios from "axios";
import Sidebar from "./Sidebar";
import ResourceContent from "./ResourceContent";
import { useSelector, useDispatch } from "react-redux";
// import { Store } from "../../Redux/store";
import { getResourcesdata } from "../../Redux/Actions/searchResponse";
import { API_FETCH } from "../../server";

const Videos = () => {
  const [swipe, setSwipe] = useState(true);
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(0);
  const { resourcesdata } = useSelector((state) => state.datalist);
  const url1 = "https://developer.sabre.com/";
  const url2 = "https://www.sabreredappcentre.sabre.com/";

  useEffect(() => {
    handleFetchVideos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFetchVideos = async () => {
    try {
      const response = await axios.get(`${API_FETCH}/resources`);
      if (response.data.success) {
        dispatch(getResourcesdata(response.data.data));
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleSwipe = () => {
    setSwipe(!swipe);
  };

  return (
    <div className="resources-container">
      <div className="blogpagee-container-bottm">
        <div
          className={
            swipe ? "exec-left-div-blogpage" : "exec-left-div-blogpage-swipe"
          }
        >
          <Sidebar
            handleSabrelab={() => {}}
            handleSabreDev={() => {
              window.open(url1, "_blank", "noopener,noreferrer");
            }}
            handleRedapp={() => {
              window.open(url2, "_blank", "noopener,noreferrer");
            }}
          />
        </div>

        <ResourceContent
          data={resourcesdata.filter(
            (item) => item.resourceType.name !== "documents"
          )}
          itemsPerPage={8}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          resourceTitle="Sabre Videos"
        />
        <div className="chevron-right-exec-cont" onClick={handleSwipe}>
          <BsChevronDoubleRight id="chevron-right-exec" />
        </div>
      </div>
    </div>
  );
};

export default Videos;
